import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Modal, Button } from "react-bootstrap";
import styled from "styled-components";

const Group = styled(Form.Group)`
  margin-bottom: 1rem;
`;
const InputContainer = styled.div`
  position: relative;
  width: 100%;

  & input {
    padding-right: "34px" !important;
    &:read-only {
      padding-right: "12px" !important;
    }
  }
`;

export function ChangeLogin({ username, onConfirm, onCancel }) {
  const [beforeSubmit, setBeforeSubmit] = useState(true);
  const [newLogin, setNewLogins] = useState("");

  const handleChangeLogin = ({ target: { value } }) => {
    setNewLogins(value);
  };

  const handleSubmit = (event) => {
    setBeforeSubmit(false);
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (!(form.checkValidity() === false || newLogin === username)) {
      onConfirm(newLogin);
    }
  };

  return (
    <Modal centered show onHide={onCancel} size="md">
      <Modal.Header style={{ border: 0 }} />
      <Form noValidate validated={false} onSubmit={handleSubmit}>
        <Modal.Body>
          <Group controlId="formBasicCurrentLogin">
            <Form.Label>Current Login</Form.Label>
            <InputContainer>
              <Form.Control readOnly type="text" name="current-login" value={username} />
            </InputContainer>
          </Group>

          <Group controlId="formBasicNewLogin">
            <Form.Label>New Login</Form.Label>
            <InputContainer>
              <Form.Control
                required
                type="text"
                placeholder="Login"
                name="new-login"
                value={newLogin}
                onChange={handleChangeLogin}
                isInvalid={!beforeSubmit}
              />
              <Form.Control.Feedback type="invalid">
                New login should be not empty and different from current!
              </Form.Control.Feedback>
            </InputContainer>
          </Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="success" type="submit">
            Update
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

ChangeLogin.propTypes = {
  username: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};
